<template>
    <a-modal title="流程图预览"
             :width="1100"
             :visible="visible"
             :maskClosable="true"
             @cancel="onCancel"
             :confirmLoading="modalLoading"
             class="wf-editor"
             :footer="null"
             destroyOnClose>
        <div id="WFContainer" style="width:1100px;height:500px;margin-bottom:4px" tabindex="0">
        </div>
    </a-modal>
</template>

<script>
export default {
  name: 'WorkflowPreview',
  data () {
    return {
      visible: false,
      modalLoading: false,
      procId: null,
    }
  },
  mounted: function () {
  },
  methods: {
    prePreview (procId) {
      this.visible = true
      this.procId = procId
      this.initWorkFlow()
    },
    onCancel () {
      this.visible = false
    },
    initWorkFlow () {
      const that = this
      this.$http.get('/api/1/workflow/design/get_process.json?id=' + this.procId).then(function (resp) {
        that.process = resp.result

        let placeholder = document.createElement('div')
        placeholder.innerHTML = that.process.svg
        let svg = placeholder.firstChild
        document.getElementById('WFContainer').appendChild(svg)
      })
    }
  }
}
</script>

<style lang="less">
    .wf-editor .ant-modal-body {
        padding: 0 !important;
    }

    #WFDesigner text {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
